const state = {
    banners: [],
    banner: {},
    error: null,
    bannersAll: []
};

export default state;
